<template>
	<div class="filterable-list__load-more-wrapper">
      <button
        v-show="isShow && isMore"
        type="button"
        class="filterable-list__load-more"
        @click="loadMore()"
      >
        <span class="filterable-list__load-more-loader">
          <span class="filterable-list__load-more-loader-box is-one"></span>
          <span class="filterable-list__load-more-loader-box is-two"></span>
          <span class="filterable-list__load-more-loader-box is-three"></span>
        </span>
        <span class="filterable-list__load-more-text">{{moreButtonlngtxt.more_txt}}</span>
      </button>
    </div>
</template>


<script>

function calculateCurrentPage(store) {
  const count = store.getters.count;      
  const pageSize = store.getters.pageSize;
  const length = store.getters.newsData.length;
  const currentPage = (length / pageSize);
  const leapPage = length % pageSize !== 0 ? 1 : 0;

  return Math.floor(currentPage) + leapPage;
}

export default {
  name: 'MoreButton',
  computed:{
    isShow() {
      return this.$store.getters.newsData.length > 0;
    },
    currentPage() {
      return calculateCurrentPage(this.$store);
    },
    totalPages(){
      return this.$store.getters.totalPages;
    },
    isMore(){      
      const totalPages = this.$store.getters.totalPages;
      return calculateCurrentPage(this.$store) < totalPages; 
    },
		moreButtonlngtxt() {
      		return this.$store.getters.lngtxt.filterablelist;
		}
  },
  methods: {
    loadMore() {
      this.$store.dispatch("getNewsroomNextPage");
    }
  }
}
</script>
